<div class="eventq-media-thumb-card__surface">
  <div class="eventq-media-thumb-card__header">
    <span class="eventq-media-thumb-card__label">{{ label() }}</span>
    @if (deletable()) {
      <button
        type="button"
        class="eventq-media-thumb-card__delete"
        aria-label="Delete"
        data-testid="media-thumb-delete"
        (click)="onDelete($event)"
      >
        <mat-icon aria-hidden="true">delete</mat-icon>
      </button>
    }
  </div>
    <button
      type="button"
      class="eventq-media-thumb-card__footage"
      [attr.aria-label]="'Open ' + label()"
      data-testid="media-thumb-open"
      (click)="onOpen()"
    >
      @if (variant() === 'clip' && videoSrc()) {
        <video
          class="eventq-media-thumb-card__image eventq-media-thumb-card__video"
          [class.eventq-media-thumb-card__video--pending]="!videoFrameReady()"
          [src]="videoSrc()"
          [poster]="imageSrc()"
          autoplay
          muted
          loop
          playsinline
          data-testid="media-thumb-video"
          (loadeddata)="markVideoFrameReady()"
        ></video>
      } @else if (showPausedVideoStill()) {
        <video
          class="eventq-media-thumb-card__image eventq-media-thumb-card__video"
          [class.eventq-media-thumb-card__video--pending]="!videoFrameReady()"
          [src]="imageSrc()"
          muted
          playsinline
          preload="metadata"
          data-testid="media-thumb-video"
          (loadeddata)="markVideoFrameReady()"
        ></video>
      } @else {
        <img class="eventq-media-thumb-card__image" [src]="imageSrc()" [alt]="label()" />
      }
    @if (variant() === 'clip') {
      <span class="eventq-media-thumb-card__play" aria-hidden="true" data-testid="media-thumb-play">
        <mat-icon>play_circle_outline</mat-icon>
      </span>
    }
  </button>
</div>
